'use client';

import type { ReactNode } from 'react';
import { AnnouncementBar } from '@/components/organisms/AnnouncementBar';
import { Header } from '@/components/Header/Header';
import { Footer } from '@/components/Footer/Footer';
import { useGlobalChrome } from '@/lib/hooks/use-global-chrome';

interface GlobalChromeProps {
  footerCompactTop: boolean;
  children: ReactNode;
}

export function GlobalChrome({ footerCompactTop, children }: GlobalChromeProps) {
  const {
    announcement,
    headerBranding,
    footer,
    hasAnnouncementBlock,
    isFetched,
    isError,
  } = useGlobalChrome();

  const showAnnouncement = isFetched && !isError && hasAnnouncementBlock && announcement;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {showAnnouncement ? <AnnouncementBar {...announcement} /> : null}
      <Header
        siteTitle={headerBranding?.siteTitle}
        logo={headerBranding?.logo}
      />
      <main id="main-content" tabIndex={-1} style={{ flex: 1 }}>
        {children}
      </main>
      <Footer
        columns={footer?.columns}
        brandName={footer?.brandName}
        compactTop={footerCompactTop}
      />
    </div>
  );
}
